// extracted by mini-css-extract-plugin
module.exports = {"infoModalContent":"Header_infoModalContent__-_qCl"};